var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 211 183",
    style: {
      enableBackground: "new 0 0 211 183"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5,23L104.1,163l87.7-138.8l0.7-1.2H27.5z M109.7,24.5l-5.5,8.8H48.3L74.5,81l-6.6,12.7L30,24.5H109.7z M102.7,86.1 l8.9,17.5l-5.5,8.4L95.3,92.2l-0.1,0.1v0H82.4L79,86.2L102.7,86.1z M125.7,103.2l-16.1-29.4H85.2L71.4,50h12l10,17.6l13,0.2 l-18.1-33h8.3l0,0l7.9,15.3h21.2v22l9,16.5l0.3-0.1L125.7,103.2z M141.9,50.1h17.4l-17.5,27.7L141.9,50.1z M68.1,94.1l14,0.9 l23.5,42.8l26.9-42.6l12.7-0.1l-41,64.8L68.1,94.1z M145.2,95.1L140,83.5l1.7-2.7l0.1,0l0-0.2l29.9-47.3h-55.9l-5.9-8.8h80 L145.2,95.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6c933c97.svg";
export { ForwardRef as ReactComponent };